import React, { Component } from 'react';
import SearchComponent from "./SearchPanel";
import withStyles from "@material-ui/core/styles/withStyles";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import dashboardStyle from "../../assets/jss/material-dashboard-react/views/dashboardStyle";
import { connect } from "react-redux";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import { EmptyRecord } from "../../utils/PageUtility";
import CircularProgress from "../../utils/CircularProgress";
import RecordTable from "./RecordTable";
import Balance from "@material-ui/icons/Money";
import { appHelpers } from "../../_helpers";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import moment from "moment/moment";


const today = new Date();
let monthAgo = new Date();
monthAgo.setDate(today.getDate() - 30);

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            StartDate: monthAgo,
            EndDate: today,
            airlines: [],
            AirlineId: '-1',
            allLocations: [],
            AirportCode: "-1",
            requestingData: true,
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            records: [],
            balance: 0,
            serviceTypesOptions: [],
            serviceType: "",
        }
    }

    componentDidMount() {
        let { regionalAirlines, user, regionalAirports, serviceTypes } = store.getState();
        const { dispatch } = this.props;

        if (user.Location) {
            this.setState({ AirportCode: user.AirportCode });
        }
        if (regionalAirlines) {
            this.setState({ airlines: regionalAirlines })
        } else {
            dispatch(commonActions.getAllAirlinesRegional());
        }
        if (serviceTypes) {
            this.setState({ serviceTypesOptions: serviceTypes });
        } else {
            dispatch(commonActions.getAllServiceTypes());
        }
        if (regionalAirports) {
            this.setState({ allLocations: regionalAirports })
        } else {
            dispatch(commonActions.getAllAirportsRegional())
        }

        /*Check Type of User*/
        if (user.AppRole === appConstants.ROLES.AIRLINE) {
            let userObj = {...user};
            let userAirline = {value: userObj.AirlineId, label: userObj.AirlineName};
            this.setState({ AirlineId: userAirline});
        } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportCode: userLocation });
        }  else if (user.Location) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportCode: userLocation });
        }

        this.setState({requestingData: false})
    }

    componentWillReceiveProps = function (nextProps) {
        const { regionalAirlines, regionalAirports, serviceTypes } = nextProps;
        if (regionalAirlines) {
            this.setState({ airlines: regionalAirlines });
        }
        if (regionalAirports) {
            this.setState({ allLocations: regionalAirports })
        }
        if (serviceTypes !== this.props.serviceTypes) {
            this.setState({ serviceTypesOptions: serviceTypes });
        }

    };

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    // handleAirlineChange = event => {
    //     this.setState({ selectedAirlineValue: event.target.value });
    // };

    // handleSelectChange = event => {
    //     this.setState({ [event.target.name]: event.target.value });
    // };

    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value });
        if (value.value === undefined || value.value === "-1"){
            this.setState({[name.name]: "-1"} )
        }
    };

    //method to search account statement
    searchAccount = (pageNumber = 1) => {
        const { AirlineId, AirportCode, pageSize, StartDate, EndDate, serviceType } = this.state;
        const { dispatch } = this.props;

        if (AirlineId === '-1') {
            dispatch(alertActions.error('Please select an airline'))
        } else if (AirportCode === '-1') {
            dispatch(alertActions.error('Please select an airport'))
        } else {
            let payload = {
                "StartDate": moment(StartDate).format('YYYY-MM-DD') + "T00:00:00",
                "EndDate": moment(EndDate).format('YYYY-MM-DD') + "T23:59:59",
                "From": pageNumber,
                "Size": pageSize,
            };

            if (AirlineId !== '-1') {
                payload.AirlineId = AirlineId.value;
            }
            if (serviceType !== '-1') {
                payload.ServiceTypeId = serviceType.value;
            }
            if (AirportCode !== '-1') {
                payload.AirportCode = AirportCode.value;
            }

            // console.log('payload', payload);
            dispatch(alertActions.startRequest());
            // this.setState({ requestingData: true });
            commonService.getStatementOfAccountRegional(payload)
                .then((res) => {
                    dispatch(alertActions.stopRequest());
                    let response = res.response;
                    // console.log('pageSize', response)
                    if (res.status === appConstants.SUCCESS_RESPONSE) {
                        this.setState({
                            currentPage: pageNumber, requestingData: false,
                            totalCount: response.Entity.TotalCount,
                            records: response.Entity.Reports,
                            balance: response.Entity.Balance
                        });
                    } else if (res.status === appConstants.ERROR_RESPONSE) {
                        dispatch(alertActions.error(res.response));
                        this.setState({ requestingData: false });
                    }
                })
        }
    };

    //method to download account statement
    downloadStatement = (type) => {
        const { dispatch } = this.props;
        const { AirlineId, AirportCode, StartDate, EndDate } = this.state;
        const payload = {
            StartDate: moment(StartDate).format('YYYY-MM-DD') + "T00:00:00",
            EndDate: moment(EndDate).format('YYYY-MM-DD') + "T23:59:59",
            Type: type
        };

        if (AirlineId !== '-1') {
            payload.AirlineId = AirlineId.value;
        }
        if (AirportCode !== '-1') {
            payload.AirportCode = AirportCode.value;
        }
        dispatch(alertActions.startRequest());
        commonService.downloadStatementOfAccountRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.success(response.Message));
                    const isBase64 = !!response.base64File;
                    const fileData = response.base64File || response; // filestream is in response directly
                    const mimeType = appHelpers.getMimeTypeFromType(payload.Type);
                    console.log(mimeType, "mimeType");
            
                    appHelpers.downloadFileV2(fileData, "Statement of Account", isBase64, mimeType);
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    if (response.Message) {
                        dispatch(alertActions.error(response.Message.join(', ')));
                    } else if (typeof response === 'string') {
                        dispatch(alertActions.error(response));
                    } else {
                        dispatch(alertActions.error("Something went wrong."));
                    }
                    this.setState({ requestingData: false });
                }
            })
    };

    render() {
        const { classes, user, requesting} = this.props;
        const { AirlineId, airlines, StartDate, EndDate, allLocations, AirportCode, serviceType,
            name, requestingData, records, totalCount, currentPage, pageSize, balance, serviceTypesOptions } = this.state;
        // console.log('currentPage', currentPage, 'totalCount', totalCount, 'pageSize',pageSize);
        if (requestingData)
            return (
                <CircularProgress />
            );

        return (
            <div>
                <GridContainer>
                    <SearchComponent
                        user={user}
                        airlines={airlines}
                        airline={name}
                        selectChange={this.handleReactSelectChange}
                        AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
                        StartDate={StartDate}
                        EndDate={EndDate}
                        onSearch={this.searchAccount}
                        handleDateChange={this.handleDateChange}
                        allLocations={allLocations}
                        serviceTypesOptions={serviceTypesOptions}
                        serviceType={serviceType.value}
                        reactSelectChange={this.handleReactSelectChange}
                        AirportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? AirportCode : AirportCode.value}
                    />
                </GridContainer>
                <GridContainer >
                    <GridItem xs={12} sm={12} md={4} className={'accountBalance'}>
                        <Card>
                            <CardHeader color="regional" stats icon>
                                <CardIcon color="regional">
                                    <Balance />
                                </CardIcon>
                                <p className={classes.cardCategory}>
                                    Balance
                                </p>
                                <h3 className={classes.cardTitle}>
                                    &#36; {appHelpers.numberWithCommasOnly(balance)}
                                </h3>
                            </CardHeader>
                            <CardFooter chart />
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="regional" >
                                <h4 className={classes.cardTitleWhite}>
                                    Account Records
                                </h4>
                            </CardHeader>
                            <CardBody>
                                {
                                    (totalCount === 0)
                                    &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <EmptyRecord message={'No record'} />
                                        </GridItem>
                                    </GridContainer>
                                }
                                {
                                    totalCount !== 0
                                    &&
                                    <RecordTable
                                        data={records}
                                        classes={classes}
                                        currentPage={currentPage}
                                        pageSize={pageSize}
                                        totalCount={totalCount}
                                        fetchMoreRecord={this.searchAccount}
                                    />
                                }
                            </CardBody>
                            {
                                totalCount !== 0 &&
                                <CardFooter chart>
                                    <div>
                                        <Button type="button" color="info" onClick={() => this.downloadStatement('pdf')} disabled={requesting}>
                                            <DownloadIcon />
                                            Download PDF
                                        </Button>
                                        <Button type="button" color="regional" onClick={() => this.downloadStatement('excel')} disabled={requesting}>
                                            <DownloadIcon />
                                            Download EXCEL
                                        </Button>
                                    </div>
                                </CardFooter>
                            }
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

//get state from store
function mapStateToProps(state) {
    const { alert, regionalAirlines, progress, airlinesPayments, user, regionalAirports, requesting, serviceTypes } = state;
    return {
        user,
        alert,
        regionalAirlines,
        progress,
        airlinesPayments,
        regionalAirports,
        requesting,
        serviceTypes
    };
}
export default connect(mapStateToProps)(withStyles(dashboardStyle)(Index));

/* Written with love by Juliet April 2019 */


// WEBPACK FOOTER //
// ./src/Regional-Views/StatementOfAccount/Index.jsx